export enum GroupsClassTransformer {
  ADMIN = 'ADMIN',
  SHOW_MAIN = 'SHOW_MAIN'
}
